import React, { useState, useEffect, useRef } from "react";
import {
  makeStyles,
  withStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content/";
import api from "../../services/api";
import "./index.css";
import { Icon } from "react-icons-kit";
import { ic_delete } from "react-icons-kit/md/ic_delete";
import { mCPF, mCNPJ, mVAL } from "../../utils/masks";
import { ic_mode_edit } from "react-icons-kit/md/ic_mode_edit";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import { colors } from '../../utils/vars'
import { formataData } from "../../utils/functions";
import { cancelCircle } from 'react-icons-kit/icomoon/cancelCircle'
import FrSelect from '../../components/FrSelect';

const swal = withReactContent(Swal);
const moment = require("moment");

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
  },
  ptBR
);

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: "#083c7c",
    },
    "& .Mui-selected:hover": {
      backgroundColor: "#083c7c",
    },
    width: "100%",
  },
  container: {
    maxHeight: "45vh",
    minHeight: "45vh",
  },
  containerDense: {
    maxHeight: "25vh",
    minHeight: "25vh",
  },

});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#083c7c",
    color: 'var(--cor-fonte)'
  },
  body: {
    fontSize: 12,
  },
}))(TableCell);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    backgroundColor: 'var(--cor-tabela)',
    color: 'var(--cor-fonte-hover)',
    transitionDuration: "0.4s",

  },
}))(TableContainer)

const StyledTablePagination = withStyles((theme) => ({
  root: {
    backgroundColor: 'var(--cor-tabela)',
    transitionDuration: "0.4s",

  },
}))(TablePagination)

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'var(--cor-tabela)',
    color: 'var(--cor-fonte-hover)',
    transitionDuration: "0.4s",
    hover: {
      backgroundColor: 'var(--cor-tabela-hover)',
    }
  },
  container: {
    backgroundColor: 'var(--cor-tabela)'
  },


}))(TableRow);

export default function FrTable(props) {
  const classes = useStyles();
  const scroll = useRef(null);
  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  // let history = useHistory();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage ? props.rowsPerPage : 25);
  const [data, setData] = useState(props.data);
  const [columns, setColumns] = useState(props.columns);
  const [order, setOrder] = React.useState(props.startOrder || 'desc');
  const [orderBy, setOrderBy] = React.useState(props.startOrderBy || props.columns[0].id);
  const [comboMot, setComboMot] = useState([{ value: '', display: '' }])

  useEffect(() => {
    async function fetchData() {
      try {
        setComboMot(await api.getComboData('motivos_cancelamento'))

        setData(props.data);
        setPage(0)
      } catch (error) {

      }

    }
    fetchData()

  }, [props.data]);

  const handleChangePage = (event, newPage) => {
    try {
      setPage(newPage);
      if (props.setPage)
        props.setPage(newPage)
    } catch (error) {

    }

  };

  const handleChangeRowsPerPage = (event) => {
    try {
      setRowsPerPage(+event.target.value);
      setPage(0);

    } catch (error) {

    }
  };


  function handleEdit(e, row) {
    e.preventDefault();

    if (props.setfk_pro)
      props.setfk_pro(row["fk_pro"]);

    if (props.setOrdenacao)
      props.setOrdenacao(row["ordenacao"]);

    if (props.setNomePro)
      props.setNomePro(row["nomepro"]);

    if (props.setPreco)
      props.setPreco(row["preco"]);

    if (props.setEdi)
      props.setEdi(row["edi"]);

    if (props.setFator)
      props.setFator(row["fator"]);

    if (props.setfk_und)
      props.setfk_und(row["fk_und"]);

    if (props.setpk_ass) {
      props.setpk_ass(row['pk_ass'])
      props.setShowModal(true);
    }
    if (props.setPk_asp) {
      props.setPk_asp(row['pk_asp'])
      props.setShowModal(true);
    }
    if (props.setPkModal) {
      props.setPkModal(row["pk"]);
    }

    if (props.setDep) {
      props.setDep(row["dep"]);
    }

    if (props.setNome) {
      props.setNome(row["nome"]);
    }

    if (props.setRecebeu_Carteira) {
      props.setRecebeu_Carteira(row["recebeu_carteira"]);
    }

    if (props.setCpf) {
      props.setCpf(row["cpf"]);
    }

    if (props.setSexo) {
      props.setSexo(row["sexo"]);
    }

    if (props.setData_Nascimento) {
      props.setData_Nascimento(row["data_nascimento"]);
    }

    if (props.setRepresentante) {
      props.setRepresentante(row["representante"]);
    }

    if (props.setFk_Grp) {
      props.setFk_Grp(row["fk_grp"]);
    }

    if (props.setVencimento) {
      props.setVencimento(row["data_venc"]);
    }

    if (props.setValor) {
      props.setValor(row["valor"]);
    }

    if (props.setUpdateModal)
      props.setUpdateModal(true);

    if (props.setPk_Cto) {
      // alert(row['pk_cto'])
      props.setPk_Cto(row['pk_cto'])
    }

    props.setModal(true);
  }

  async function handleCancel(e, row) {
    e.preventDefault();

    const { value: formValues } = await swal.fire({
      title: '',
      html: (
        <div >

          <h6>{"Cancelamento de Dependente " + row['nome']}</h6>
          <FrSelect
            name="fk_mot"
            id="fk_mot"
            label='Motivo'
            data={comboMot}
            style={{ width: 250 }}
          />

        </div>
      ),
      focusConfirm: true,
      preConfirm: () => {
        return {
          fk_mot: document.getElementById("fk_mot").value,
        };
      },
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "OK",
      confirmButtonColor: `#083c7c`,
      allowOutsideClick: false,
    })

    if (formValues && formValues["fk_mot"]) {
      const dataAtual = new Date();
      const dataFormatada = moment(dataAtual).format('YYYY-MM-DD')

      await api.get('/motivos_cancelamento?pk_mot=' + formValues["fk_mot"]).then(res => {
        let nomemot = res.data[0].descricao

        let item = [];
        let i;
        for (i = 0; i < data.length; i++) {
          if (data[i].pk == row['pk']) {
            item.push({
              dep: data[i].dep,
              nome: data[i].nome,
              cpf: data[i].cpf,
              sexo: data[i].sexo,
              data_nascimento: data[i].data_nascimento,
              representante: data[i].representante,
              fk_grp: data[i].fk_grp,
              recebeu_carteira: data[i].recebeu_carteira,
              pk: data[i].pk,
              formatData: data[i].formatData,
              nomegrp: data[i].nomegrp,
              data_cadastro: data[i].data_cadastro,
              fk_mot: formValues["fk_mot"],
              nomemot: nomemot,
              data_cancelado: dataFormatada
            });

          } else {
            item.push({
              dep: data[i].dep,
              nome: data[i].nome,
              cpf: data[i].cpf,
              sexo: data[i].sexo,
              data_nascimento: data[i].data_nascimento,
              representante: data[i].representante,
              fk_grp: data[i].fk_grp,
              recebeu_carteira: data[i].recebeu_carteira,
              pk: data[i].pk,
              formatData: data[i].formatData,
              nomegrp: data[i].nomegrp,
              data_cadastro: data[i].data_cadastro,
              fk_mot: data[i].fk_mot,
              nomemot: data[i].nomemot,
              data_cancelado: data[i].data_cancelado
            });
          }

          if (i + 1 == data.length) props.setDataGrid(item);

        }

      })
    }

  }

  function handleDelete(e, name, pk) {
    e.preventDefault();
    swal
      .fire({
        title: `<h2 style='color: ${colors.info900}'>ATENÇÃO</h2>`,
        text: "Deseja excluir o registro selecionado?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: colors.success500,
        cancelButtonColor: colors.danger500,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      })
      .then((result) => {
        if (props.desvinculaCtr) {
          let i = []
          props.itens.forEach(item => {
            if (item != name) {
              i.push(item)
            }
          })
          // console.log(i)
          props.setItens(i)
          api.post('itens_cobranca/desvincula?pk=' + name).then(r => {

          })
        } else {
          if (result.value) {
            // alert(props.regName)
            if (props.regName == 'cliente_produto') {
              api.post('/cliente_produto/delete/' + pk).then(r => {
                // console.log(r.data)
                if ((r.status === 200) && (r.data.substr(0, 5) !== 'Erro!')) {
                  swal.fire({
                    title: `<h2 style='color:${colors.info900}'>Registro Excluído</h2>`,
                    text: "O registro foi excluído com sucesso!",
                    icon: 'success',
                  }).then((result) => {
                    if (result.value) {
                      window.location.reload()
                    }
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi excluído! " + r.data,
                    icon: 'warning',
                  })
                }
              }).catch(e => {
                //console.log(e.response.data)
                if (e.response?.data?.sqlMessage && e.response?.data?.sqlMessage.indexOf('Cannot delete or update a parent row: a foreign key constraint fails') >= 0) {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "O registro não foi excluído pois possui outros registros vinculados! ",
                    icon: 'warning',
                  })
                } else {
                  swal.fire({
                    title: `<h2 style='color: ${colors.info900}'>Erro!</h2>`,
                    text: "Houve um problema na exclusão do registro!",
                    icon: 'warning',
                  })
                }
              })

            } else {

              var sliced = [];
              for (var i = 0; i < data.length; i++)
                if (pk > 0) {
                  if (data[i].pk !== pk && data[i].pk > 0) {
                    sliced.push(data[i]);
                  }
                } else {
                  if (data[i].display !== name && data[i].display !== "") {
                    sliced.push({
                      value: data[i].value,
                      display: data[i].display,
                    });
                  }
                }
              if (sliced.length === 0) {
                sliced.push({
                  value: "",
                  display: "",
                  pk: 0,
                });
              }

              if (props.setDataGrid) {
                props.setDataGrid(sliced);
              }
            }
          }

        }
      });
  }

  const handleClick = (event, name, campo, row) => {
    if (props.setCto) {
      props.setCto(row['pk_cto'])
    }

  };

  return (
    <ThemeProvider theme={theme}>
      {data.length === 0 ? (
        <div>{props.searched ? props.emptyMessage : ""}</div>
      ) : (
        <Paper className={classes.root}>
          <StyledTableContainer className={props.dense ? classes.containerDense : classes.container}>
            {/* <Table stickyHeader aria-label="sticky table"> */}
            <Table
              stickyHeader={props.regName == 'cliente_produto'}
              className={classes.table}
              size="small"
              aria-label="a dense table"
            >

              <TableHead >
                <StyledTableRow className="custom-cursor">
                  {!props.readonly ? (
                    <StyledTableCell
                      style={{ minWidth: 100, width: 100 }}
                    ></StyledTableCell>
                  ) : (
                    <></>
                  )}
                  {columns.map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {props.regName == 'cliente_produto' ? <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                        onClick={createSortHandler(
                          column.order ? column.order : column.id
                        )}
                      >
                        {column.label}

                      </TableSortLabel> : <>{column.label}</>}
                    </StyledTableCell>
                  ))}

                  <StyledTableCell style={{ minWidth: 30, width: 30 }} />
                </StyledTableRow>
              </TableHead>
              <TableBody
                className="custom-cursor"
                ref={scroll}
              >
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <StyledTableRow
                        tabIndex={-1}
                        onClick={(event) =>
                          handleClick(
                            event,
                            row[props.codeName],
                            props.codeName,
                            row
                          )
                        }
                        key={row[props.codeName]}
                      >
                        {(!props.readonly &&
                          (row[props.codeName] !== "" || row["pk"] > 0)) ? (
                          <TableCell>
                            {(props.regName !== 'contratos') && (props.regName !== 'ctrec') && (props.regName !== 'contratos_empresas') ? (

                              <Icon
                                className="tableDelete"
                                icon={ic_delete}
                                size={18}
                                onClick={(e) =>
                                  handleDelete(e, row[props.codeName], row["pk"])
                                }
                              />
                            ) : <></>}

                            {(props.regName == 'contratos') && (!row['data_cancelado']) ? (
                              <Icon
                                className="tableOkRed"
                                icon={cancelCircle}
                                size={18}
                                onClick={(e) => handleCancel(e, row)}
                              />
                            ) : (
                              <></>
                            )}

                            {((props.editar) && (!row['data_cancelado'])) ? (
                              <Icon
                                className="tableDelete"
                                icon={ic_mode_edit}
                                size={18}
                                onClick={(e) => handleEdit(e, row)}
                              />
                            ) : (
                              <></>
                            )}
                          </TableCell>
                        ) : (
                          <></>
                        )}

                        {
                          columns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell key={column.id} align={column.align}

                              >
                                {column.format && typeof value === 'number' ? column.format(value) :
                                  column.cpf && value && row['tipo'] <= 14 ? mCPF(value) :
                                    column.cpf && value && row['tipo'] > 14 ? mCNPJ(value) :
                                      column.date && value ? moment(value.substr(0, 10)).format('DD/MM/YYYY') :
                                        // column.date && value ? formataData(value) :
                                        column.moeda && value ? mVAL(value * 100, 2) :
                                          value}
                              </TableCell>
                            );
                          })
                        }
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </StyledTableContainer>
          <StyledTablePagination
            rowsPerPageOptions={[5, 10, 12, 25, 100]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </ThemeProvider>
  );
}
